import React from "react";
import img1 from "../../Assets/Images/serviceImages/img1.webp";
import img2 from "../../Assets/Images/serviceImages/img2.webp";
import img3 from "../../Assets/Images/serviceImages/img3.webp";
import img4 from "../../Assets/Images/serviceImages/img4.webp";
import img5 from "../../Assets/Images/serviceImages/img5.webp";
import img6 from "../../Assets/Images/serviceImages/img6.webp";
import img7 from "../../Assets/Images/serviceImages/img7.webp";
import img8 from "../../Assets/Images/serviceImages/img8.webp";
import img9 from "../../Assets/Images/serviceImages/img9.webp";
const TopCard = () => {
  const images = [
    {
      img: img1,
    },
    {
      img: img2,
    },
    {
      img: img3,
    },
    {
      img: img4,
    },
    // {
    //   img: img5,
    // },
    {
      img: img6,
    },
    {
      img: img7,
    },
    {
      img: img8,
    },
    {
      img: img9,
    },
  ];
  return (
    <div className="w-full h-full mb-0.5">
      <div className="flex">
        {images.map((item, index) => (
          <div key={index}>
            <img alt="" src={item.img} className="w-52"/>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopCard;
